import { render, staticRenderFns } from "./EditUsuario.vue?vue&type=template&id=01c55016&scoped=true"
import script from "./EditUsuario.vue?vue&type=script&lang=js"
export * from "./EditUsuario.vue?vue&type=script&lang=js"
import style0 from "./EditUsuario.vue?vue&type=style&index=0&id=01c55016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c55016",
  null
  
)

export default component.exports